module.exports = __webpack_public_path__ + "static/media/cabania.be6be4ae.webp";